import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// store
import { Store } from '@ngrx/store';
import { Subject, Subscription, throwError } from 'rxjs';
import { Observable } from 'rxjs';
//import 'rxjs/add/operator/retry';
import { takeWhile, map, catchError,retry } from 'rxjs/operators';
import { take } from 'rxjs/operators';

// services
import { ErrorHandler } from '../../shared/services/error-handler.service';
import { DataStorageService } from '../../shared/services/data-storage.service';
import { SharedService } from '../../shared/services/shared-service.service';
// models
import { AppState } from '../models/app-state.interface';
import { PricingItem } from '../models/pricing.interface';
import { PriceUpdateValues } from '../models/price-update-values.interface';
import { DeleteCardRequest } from '../models/delete-card-request.interface';
// init models
import { initialPricing } from '../models/pricing-init.model';
// globals
import { API_PATH, SUBSCRIPTION_KEY, PRICING, PROMO_VALID, DELETE_SAVED_CARD, CURRENCY_CODES, SLOT_NUMBER } from '../../shared/globals';
// external libs
import moment from 'moment';
import { BookingService } from './booking.service';
import { updatePriceObject, updatePriceStatus, updateSbbSubsidyAmount } from '../reducers/price.reducer';
import { removePromo, updateBookingAmendType, updatePremiumSurcharge, updatePromo, updateTotalPrice } from '../reducers/booking.actions';
import { savePromoCode } from '../reducers/d2d-booking.reducer';
import { updateCurrency } from '../reducers/timeslot.reducer';
import { PRICE_LOADED } from '@shared/reducers/loading-status.reducer';
import { updateMaxMilesRange } from '../reducers/milesAndMore.reducer';

type PriceRequst = { request: PricingItem, isPaymentScreen?: boolean, selectedMiles?: number, MilesRatio?: number, hasChargeApplied?: boolean }
@Injectable({
  providedIn: 'root',
})
export class PriceService {

  public pricingSubject$: Subject<any> = new Subject();
  public pricingQuoteSubject$: Subject<any> = new Subject();
  public updatePromoSubject$: Subject<any> = new Subject();
  public priceErrorSubject$: Subject<any> = new Subject();
  public cardRemovedSubject$: Subject<any> = new Subject();
  public cardRemovedRequestSent$: Subject<any> = new Subject();
  public priceUpdating$: Subject<any> = new Subject();
  public priceLoaded$: Subject<any> = new Subject();

  private _priceApiSubscription: Subscription;
  private _initalPricing: PricingItem = initialPricing;
  private _pricingOriginal = Object.assign({}, this._initalPricing);
  private _priceUpdateValues: PriceUpdateValues = {
    postCode: '',
    geoCoord: {
      latitude: 0,
      longitude: 0
    },
    bagCount: null
  };
  private _priceLoaded = false;
  private _emptyTimeslotIdGuid = '00000000-0000-0000-0000-000000000000';

   constructor (
    private router: Router,
    private _activatedRoute: ActivatedRoute,
    private _http: HttpClient,
    private _appStore: Store<AppState>,
    private _bookingService: BookingService,
    private _errorService: ErrorHandler,
    private _dataStorageService: DataStorageService,
    private _sharedService: SharedService
  ) { }

  createAuthorizationHeader(headers: HttpHeaders, token) {
    headers = headers.set('Authorization', 'bearer ' + token);
    return headers;
   }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
    .subscribe(s => state = s);
    return state;
  }

  formatAirportLocation() {
    const bookingState = this.getState(this._appStore);
    const lastBookingState = bookingState.currentBookingReducer.currentBooking;
    const direction = bookingState.bookingReducer.bookingDetails.journeyLegDetails[0].journeyDirection;

    const airportShortName = direction === 1 ? lastBookingState.bookingJourney[0].deliveryLocation.shortName :
          lastBookingState.bookingJourney[0].collectionLocation.shortName;
    const airportId = direction === 1 ? lastBookingState.bookingJourney[0].deliveryLocation.locationId :
          lastBookingState.bookingJourney[0].collectionLocation.locationId;

    let airportLocation;

    if (airportShortName === null) {
      if (airportId === 'd61bf9a4-c40a-4b5a-a642-180e6e9e6b9a' || airportId === 'cbc4b6c7-2f75-478e-80e6-c918b8a0268e') {
        airportLocation = 1;
      } else if (airportId === '463218bf-f52d-4468-8ffd-438f1174d115' || airportId === '2d9df515-4f14-44d8-ad22-6b3cd29aeb2a') {
        airportLocation = 2;
      } else if (airportId === '98c646b6-dbdc-4f43-adf5-d7c7fea70942') {
        airportLocation = 3;
      } else if (airportId === '73403ED3-652C-41EF-B16A-B20FE46F6B5F') {
        airportLocation = 4;
      } else if (airportId === 'AAFF79F6-6ADF-4726-AD2F-790C98EE1804' || airportId === '9E829D4E-C760-46A8-A79B-D71BBD1FA6E5' || airportId === '85FC337C-93ED-4DB0-9B20-D1708B756988') {
        airportLocation = 5;
      }
    } else {
      if (airportShortName.includes('LHR')) {
        airportLocation = 1;
      } else if (airportShortName.includes('LGW')) {
        airportLocation = 2;
      } else if (airportShortName.includes('LCY')) {
        airportLocation = 3;
      } else if (airportShortName.includes('LTN')) {
        airportLocation = 4;
      } else if (airportShortName.includes('MAN')) {
        airportLocation = 5;
      } else if (airportShortName.includes('GVA')) {
        airportLocation = 6;
      }else if (airportShortName.includes('ZRH')) {
        airportLocation = 7;
      } else if (airportShortName.includes('DUB')) {
        airportLocation = 8;
      } else if (airportShortName.includes('VIE')) {
        airportLocation = 9;
      }
    }

    return airportLocation;
  }

  updatePriceLocation(postCodeData) {
    this._priceUpdateValues.postCode = postCodeData.postCode;
    this._priceUpdateValues.geoCoord = postCodeData.goeCoord;
    this.getPrice('location');
  }

  updatePriceBags(bagCount) {
    this._priceUpdateValues.bagCount = bagCount;
    this.getPrice('bags');
  }

  formatPriceRequest(priceType?) {

    const bookingState = this.getState(this._appStore);
    const currentBooking = bookingState.currentBookingReducer.currentBooking;
    const timeSlotServiceDate = bookingState.currentBookingReducer.timeSlotServiceDate;
    const booking = bookingState.bookingReducer.bookingDetails;
    const timeslot = bookingState.timeslotReducer;
    const user = bookingState.userReducer.userDetails;
    let request = this._pricingOriginal;
    const addBookingCalled = booking.addBookingCalled;
    const timeSlotRed = bookingState.timeslotReducer.selectedTimeslotDateTime;
    const flightReducer = bookingState.flightReducer;

    // console.log(timeSlotRed, currentBooking)

    request.getJourneyPriceRequest[0].airportLocation = currentBooking.bookingJourney[0].flightData !== null &&
      currentBooking.bookingJourney[0].flightData.flightInfoId !== '' ? this.formatAirportLocation() : 1;

    request.getJourneyPriceRequest[0].collectionDateTimeUTC = currentBooking.bookingJourney[0].collectionDateTimeUTC !== '' ?
      currentBooking.bookingJourney[0].collectionDateTimeUTC : moment().format('YYYY-MM-DD');

    request.getJourneyPriceRequest[0].deliveryDateTimeUTC = currentBooking.bookingJourney[0].deliveryDateTimeUTC !== '' ?
      currentBooking.bookingJourney[0].deliveryDateTimeUTC : moment().format('YYYY-MM-DD');

    request.getJourneyPriceRequest[0].flightDepartureAirportCode = flightReducer.flightDetails.flightResponse.flightStatusDetails[0].departureAirport.airportCode;

    request.getJourneyPriceRequest[0].flightDateTime = currentBooking.bookingJourney[0].flightData.requestDepartureDate !== '' ?
      currentBooking.bookingJourney[0].flightData.requestDepartureDate : null;

    // in amends product tier can't be changed...
    // get from current booking obj
    // if timeslot id is null - set to 'fake' guid
    // handled by the b/e
    if (booking.bookingType === 'amend') {
      // if (booking.bookingProduct === 'ccd') {
      //   request.getJourneyPriceRequest[0].deliveryDateTimeUTC = timeSlotRed !== '' ? timeSlotRed : moment().format('YYYY-MM-DD');
      // }
      request.getJourneyPriceRequest[0].productTierId = currentBooking.bookingJourney[0].productTierId;
      if (timeslot.selectedTimeslotId === null) {
        request.getJourneyPriceRequest[0].timeslotId = typeof currentBooking.bookingJourney[0].timeSlotId === 'undefined' ? this._emptyTimeslotIdGuid : currentBooking.bookingJourney[0].timeSlotId;
      } else {
        request.getJourneyPriceRequest[0].productTierId = timeslot.selectedGroup.productTierId;
        request.getJourneyPriceRequest[0].timeslotId = timeslot.selectedTimeslotId;
      }
      request.bookingReference = booking.bookingReference;
      request.bookingJourneyReference = booking.bookingJourneyReference;
      if (bookingState.utilityReducer.isHubdropBooking) {
        request.getJourneyPriceRequest[0].zoneId = currentBooking.bookingZoneId;
      } else {
        request.getJourneyPriceRequest[0].zoneId = null;
      }
    } else {
      request.getJourneyPriceRequest[0].productTierId = timeslot.selectedGroup === null ? '' : timeslot.selectedGroup.productTierId;
      request.getJourneyPriceRequest[0].timeslotId = timeslot.selectedTimeslotId === null ? '' : timeslot.selectedTimeslotId;
    }

    request.getJourneyPriceRequest[0].journeyDirection = booking.journeyLegDetails[0].journeyDirection;

    if (currentBooking.bookingJourney[0].virtualBagCount > 0) {
      request.getJourneyPriceRequest[0].numberOfBags = currentBooking.bookingJourney[0].virtualBagCount;

      const OversizeItem = Number(bookingState.bookingReducer.bookingDetails.bagItems.oversizeItem)
      // console.log('OversizeItem', OversizeItem);
      request.getJourneyPriceRequest[0].numberOfOversizedBags = OversizeItem || 0;
    } else if (bookingState.bookingReducer.bookingDetails.virtualBagCount > 0) {
      request.getJourneyPriceRequest[0].numberOfBags = bookingState.bookingReducer.bookingDetails.virtualBagCount;

      const oversizeItem = Number(bookingState.bookingReducer.bookingDetails.bagItems.oversizeItem);
      // console.log('oversizeItem', oversizeItem);
      request.getJourneyPriceRequest[0].numberOfOversizedBags = oversizeItem || 0;
    } else {
      request.getJourneyPriceRequest[0].numberOfBags = 1;
      request.getJourneyPriceRequest[0].numberOfOversizedBags = 0;
    }

    if (request.getJourneyPriceRequest[0].journeyDirection === 2) {
      const flightData = bookingState.flightReducer.flightDetails.flightResponse;
      request.getJourneyPriceRequest[0].flightDateTime = flightData.flightStatusDetails[flightData.flightStatusDetails.length - 1].arrivalDateTimeDetails.scheduledDateTimeLocal;
    }

    if (bookingState.bookingReducer.bookingDetails.bookingType !== 'amend' || (bookingState.bookingReducer.bookingDetails.bookingType === 'amend' && bookingState.timeslotReducer.selectedDate !== null)) {
      /**
       * @ABC
       * deliveryDateTimeUTC = flightDateTime
       * collectionDateTimeUTC = timeSlotServiceDate
       */
      if (request.getJourneyPriceRequest[0].journeyDirection === 1) {
        request.getJourneyPriceRequest[0].deliveryDateTimeUTC = request.getJourneyPriceRequest[0].flightDateTime;
        if (timeSlotServiceDate) request.getJourneyPriceRequest[0].collectionDateTimeUTC = timeSlotServiceDate.toString();
      }
      /**
       * @CCD
       * collectionDateTimeUTC = flightDateTime
       * deliveryDateTimeUTC = timeSlotServiceDate
       */
      if (request.getJourneyPriceRequest[0].journeyDirection === 2) {
        request.getJourneyPriceRequest[0].collectionDateTimeUTC = request.getJourneyPriceRequest[0].flightDateTime;
        if (timeSlotServiceDate) request.getJourneyPriceRequest[0].deliveryDateTimeUTC = timeSlotServiceDate.toString();
      }
    }

    if (request.getJourneyPriceRequest[0].journeyDirection === 1) {
      if (currentBooking.bookingJourney[0].collectionLocation.addressPostCode !== '') {
        request.getJourneyPriceRequest[0].postCode = currentBooking.bookingJourney[0].collectionLocation.addressPostCode;
        request.getJourneyPriceRequest[0].geocoord = currentBooking.bookingJourney[0].collectionLocation.geoCoord;
      } else if (booking.quote.data.length > 0 && booking.quote.data[0].hasOwnProperty('placeObj') &&
        booking.quote.data[0].placeObj.addressPostCode !== '') {
        request.getJourneyPriceRequest[0].postCode = booking.quote.data[0].placeObj.addressPostCode;
        request.getJourneyPriceRequest[0].geocoord = booking.quote.data[0].placeObj.geoCoord;
      } else {
        request.getJourneyPriceRequest[0].postCode = 'SW1E 5ND';
      }
    } else if (request.getJourneyPriceRequest[0].journeyDirection === 2) {
      if (currentBooking.bookingJourney[0].deliveryLocation.addressPostCode !== '') {
        request.getJourneyPriceRequest[0].postCode = currentBooking.bookingJourney[0].deliveryLocation.addressPostCode;
        request.getJourneyPriceRequest[0].geocoord = currentBooking.bookingJourney[0].deliveryLocation.geoCoord;
      } else if (booking.quote.data.length > 0 && booking.quote.data[0].hasOwnProperty('placeObj') &&
        booking.quote.data[0].placeObj.addressPostCode !== '') {
        request.getJourneyPriceRequest[0].postCode = booking.quote.data[0].placeObj.addressPostCode;
        request.getJourneyPriceRequest[0].geocoord = booking.quote.data[0].placeObj.geoCoord;
      } else {
        request.getJourneyPriceRequest[0].postCode = 'SW1E 5ND';
      }
    }

    if (priceType === 'location') {
      request.getJourneyPriceRequest[0].postCode = this._priceUpdateValues.postCode;
      request.getJourneyPriceRequest[0].geocoord = this._priceUpdateValues.geoCoord;
    }

    if (priceType === 'bags') {
      request.getJourneyPriceRequest[0].numberOfBags = this._priceUpdateValues.bagCount;
      // console.log('this._priceUpdateValues.bagCount',this._priceUpdateValues.bagCount)
    }

    if (priceType === 'timeslot') {
      request.isFromTimeSlotPage = true;
    } else {
      request.isFromTimeSlotPage = false;
    }

    const flightDirection = bookingState.flightReducer.flightDetails.flightResponse.flightDirection;
    const ccd = bookingState.flightReducer.flightDetails.flightProducts.ccd;
//     const flightDirection = 2
//     const ccd = true;
// // console.log(flightDirection, ccd)
// // console.log(ccd && flightDirection === 2);


    if (booking.bookingProduct === 'ccd') {
      request.getJourneyPriceRequest[0].addOnProductTypes = [2];
    }

    if (booking.bookingProduct === 'abc') {
      request.getJourneyPriceRequest[0].addOnProductTypes = [1];
    }

    // if(ccd && flightDirection === 2) {
    //   request.getJourneyPriceRequest[0].addOnProductTypes = [2];
    // }


    if (booking.bookingReference && addBookingCalled) {
      request.bookingReference = booking.bookingReference;
    }

    request.promoCodes = typeof booking.promo === 'undefined' ? [] : booking.promo;
    request.userEmailAddress = user.userEmail !== '' ? user.userEmail : null;

    const storedUserEmail = atob(sessionStorage.getItem('ue'));
    if (storedUserEmail && !request.userEmailAddress) {
      request.userEmailAddress = storedUserEmail;
    }

    if (bookingState.bookingReducer.bookingDetails.isD2dService && bookingState.d2dReducer.addBookingCount === 1 && bookingState.d2dReducer.promoCode.length === 0) {
      request.promoCodes = []
    }

    const priceLoaded = this.getState(this._appStore).loadedStatusReducer.priceLoaded;
    if (!request.userEmailAddress && request.promoCodes.length > 0 && !priceLoaded) {
      request = JSON.parse(JSON.stringify(request));
      request.promoCodes.pop();
    }
    request.getJourneyPriceRequest[0].airlineCode = booking.carrier.originalAirlineCode;
    request.getJourneyPriceRequest[0].isDoorToDoorBooking = bookingState.bookingReducer.bookingDetails.isD2dService;

    const flybackReducer = bookingState.flybackReducer
    const flyBack = flybackReducer.flybackBooking
    const flyBackRedirect = flybackReducer.flyBackRedirect
    if(flyBack && !flyBackRedirect) {
      request.applySbbSubsidy = bookingState.oldBookingInfoReducer.abcBooking.bookingReducer.bookingDetails.isSbbSubsidyApplied;
    } else {
      request.applySbbSubsidy = bookingState.bookingReducer.bookingDetails.isSbbSubsidyApplied;
    }
    if (booking.bookingType !== 'amend') {
      if (bookingState.hubDropReducer.selectedPostOffice) {
        request.getJourneyPriceRequest[0].zoneId = bookingState.hubDropReducer.selectedPostOffice.zoneId;
      } else {
        request.getJourneyPriceRequest[0].zoneId = null;
      }
    }

    request.slotNumber = this._sharedService.getCurrentSlotNumber();
    // console.log('request',request);
    return request;

  }


  getPriceRequest(priceType?): PriceRequst {
    const state = this.getState(this._appStore);
    const booking = state.bookingReducer.bookingDetails;
    const request = this.formatPriceRequest(priceType);
    const bookingAmendType = state.bookingReducer.bookingDetails.bookingAmendType;
    const collectionDateTimeUTC = new Date(request.getJourneyPriceRequest[0].collectionDateTimeUTC);
    const deliveryDateTimeUTC = new Date(request.getJourneyPriceRequest[0].deliveryDateTimeUTC);
    collectionDateTimeUTC.setHours(0, 0, 0, 0);
    deliveryDateTimeUTC.setHours(0, 0, 0, 0);
    const hasChargeApplied = collectionDateTimeUTC.getTime() === deliveryDateTimeUTC.getTime();
    // console.log(request, 'request', priceType, 'priceType');
    this._bookingService.updateD2dstate();
    const isPaymentScreen = window.location.pathname.split('/')[2] === 'payment';
    if (request.getJourneyPriceRequest[0].productTierId === '') {
      return;
    };
    if (booking.bookingType === 'amend' && (state.currentBookingReducer.currentBooking.bookingZoneId !== booking.zoneInfo.zoneId && booking.zoneInfo.zoneId !== '')) {
      return;
    }
    const milesReducer = state.milesAndMoreReducer;
    let selectedMiles;
    if (state.bookingReducer.bookingDetails.bookingProduct === 'abc') {
        selectedMiles = milesReducer.payByMilesResponse?.abcMilesSubmitted;
      } else {
      selectedMiles = milesReducer.payByMilesResponse?.ccdMilesSubmitted;
    }
    const MilesRatio = milesReducer.miles?.currencyRatio;
    if (selectedMiles && MilesRatio && milesReducer.milesVerified?.status === 'AUTHORISED' && bookingAmendType !== 'refund') {
      request.getJourneyPriceRequest[0].selectedMiles = selectedMiles;
      request.getJourneyPriceRequest[0].milesCurrencyRatio = MilesRatio;
    }

    if (bookingAmendType === 'refund' || milesReducer.milesVerified?.status !== 'AUTHORISED') {
      request.getJourneyPriceRequest[0].selectedMiles = null;
      request.getJourneyPriceRequest[0].milesCurrencyRatio = null;
    }

    return { request, isPaymentScreen, selectedMiles, MilesRatio, hasChargeApplied};
  }

  getPriceResponseHander(price: any, data: PriceRequst, priceType?) {
    const {
      request,
      MilesRatio,
      selectedMiles,
      isPaymentScreen,
      hasChargeApplied
    } = data;
    const priceRes = price;
    this.priceUpdating$.next(false);
    this.priceLoaded$.next(price);
    this._appStore.dispatch(updatePriceStatus({ priceLoading: false }));
    this._appStore.dispatch(savePromoCode({payload: [...request.promoCodes] }));
    if (priceType !== 'quote') {
      if (priceRes.totalPrice !== null) {
        this._appStore.dispatch(updatePriceObject({ priceObj: priceRes }));
        this._appStore.dispatch(updateTotalPrice({ payload: priceRes.totalPrice.majorAmount }));
        this._appStore.dispatch(updatePremiumSurcharge({ payload: {charge: priceRes.pricingResponse[0].pricingBreakdown.premiumSurchargePriceMajor, hasApplied: hasChargeApplied}}));
        this._appStore.dispatch(updateSbbSubsidyAmount({ subsidyAmount: priceRes.pricingResponse[0].pricingBreakdown.sbbSubsidyMajor }));
        this._appStore.dispatch(updateCurrency({ currency: CURRENCY_CODES[priceRes.totalPrice.currencySymbol] }));
        if (!this.getState(this._appStore).loadedStatusReducer.priceLoaded) {
          this._appStore.dispatch(PRICE_LOADED({ priceLoaded: true }));
        }
        const miles = this.getState(this._appStore).milesAndMoreReducer;
        if (miles.errorType !== 'low_miles' && miles.isUserLoggedIn && !miles.milesRedeemed) {
          const { totalD2dPrice } = this._bookingService.getD2dDiscountPrice(priceRes);
          let newMaxMiles = Math.ceil(totalD2dPrice * miles.miles?.currencyRatio) || 0;
          const milesBalance = miles.miles.milesBalance;
          if (milesBalance < newMaxMiles) {
            newMaxMiles = milesBalance;
          }
          this._appStore.dispatch(updateMaxMilesRange({ payload: newMaxMiles }));
        }
        this.setTransactionStatus(priceRes.priceHistory.transactionStatus);
        setTimeout(() => {
          this._bookingService.updateD2dstate();
          if ((selectedMiles && MilesRatio) || isPaymentScreen) {
            this._dataStorageService.saveData();
          }
        },0);
      }
    } else {
      this.pricingQuoteSubject$.next(priceRes);
    }

    if (!this._priceLoaded && priceRes.totalPrice !== null) {
      this._priceLoaded = true;
      this._appStore.dispatch(PRICE_LOADED({ priceLoaded: this._priceLoaded }));
    }

    if (priceRes.validationErrors && priceRes.validationErrors.length > 0) {
      let params = {};
      const error = {
        text: '',
        sticky: true
      }

      try {
        if (priceRes.translationResponse) {
          error.text = priceRes.translationResponse.translationValidationErrors[0].errorMessage;
          params = priceRes.translationResponse.translationValidationErrors[0].parameters;
          this._errorService.handleCustomError(error);
        } else {
          error.text = priceRes.validationErrors[0];
          this._errorService.handleCustomError(error);
        }
      } catch (error) {
        // console.log(error);
      }

    }
  }

  getPrice(priceType?) {
    let data = this.getPriceRequest(priceType);
    if (!data) { return; }

    if (this._activatedRoute.snapshot.queryParams['d2d'] === 'falseD2D') {
      data.request.getJourneyPriceRequest[0].isDoorToDoorBooking = false;
    }
    const { request } = data;
    // console.log('just about to call api',this.getState(this._appStore).currentBookingReducer, this.getState(this._appStore).bookingReducer.bookingDetails)

    this.priceUpdating$.next(true);
    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    this._appStore.dispatch(updatePriceStatus({ priceLoading: true }));
    if (this._priceApiSubscription) { this._priceApiSubscription.unsubscribe(); }
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    this._priceApiSubscription = this._http
      .post(API_PATH + PRICING, request, {headers:headers})
      .subscribe(
        (price:any) => {
          this.getPriceResponseHander(price, data, priceType);
        },
        err => {
          this.priceUpdating$.next(false);
          this.priceErrorSubject$.next(err);
          this._errorService.handleError(err);
          this._appStore.dispatch(updatePriceStatus({ priceLoading: false }));
        });

  }

  getPricePromise(priceType?) {
    const promise = new Promise((resolve, reject) => {
    const data = this.getPriceRequest(priceType);
    if (!data) { return; }
    const { request } = data;
    this.priceUpdating$.next(true);
    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    this._appStore.dispatch(updatePriceStatus({ priceLoading: true }));
    if (this._priceApiSubscription) { this._priceApiSubscription.unsubscribe(); }
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
      this._http
        .post(API_PATH + PRICING, request, { headers: headers })
        .toPromise()
        .then((price:any) => {
          this.getPriceResponseHander(price, data, priceType);
          resolve(price);
        })
        .catch((err) => {
          this.priceUpdating$.next(false);
          this.priceErrorSubject$.next(err);
          this._errorService.handleError(err);
          this._appStore.dispatch(updatePriceStatus({ priceLoading: false }));
          resolve('error');
        });
    });
    return promise;
  }

  setTransactionStatus(v) {
    switch (v) {
      case 2:
        this._appStore.dispatch(updateBookingAmendType({ payload: 'refund' }));
        return;

      case 3:
        this._appStore.dispatch(updateBookingAmendType({ payload: 'payment' }));
        return;

      default:
        this._appStore.dispatch(updateBookingAmendType({ payload: 'none' }));
        return;
    }
  }

  checkIfPromoValid(request, token?) {

    this.priceUpdating$.next(true);
    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    this._http
      .post(API_PATH + PROMO_VALID, request, {headers:headers})
      .subscribe((res: any) => {
        if (res.value) {
          const userEmail = this.getState(this._appStore).userReducer.userDetails.userEmail;
          if (userEmail) {
            const encodedString = btoa(userEmail)
            sessionStorage.setItem('ue', encodedString);
          }
          this._appStore.dispatch(updatePromo({ payload: request.promoCode }));
          this._appStore.dispatch(savePromoCode({payload: [request.promoCode] }));
          this.updatePromoSubject$.next(res.value);
          return;
        } else {
          this.updatePromoSubject$.next(false);
        }
      },
      err => {
        this.priceUpdating$.next(false);
        this.updatePromoSubject$.next(err);
        this._errorService.handleError(err);
      });
  }

  removeSetPromo(code, isSwitch?: boolean) {
    this._appStore.dispatch(removePromo({ payload: [] }));
    if (isSwitch) {
      this._appStore.dispatch(savePromoCode({ payload: [code] }));
    } else {
      this._appStore.dispatch(savePromoCode({ payload: [] }));
    }
    this.getPrice();
  }

  removeSavedCard(ref, id, token, successMessage) {

    this.cardRemovedRequestSent$.next(true);

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);


    const request: DeleteCardRequest = {
      userId: id,
      recurringDetailReference: ref
    };

    this._http
      .post(API_PATH + DELETE_SAVED_CARD, request, {headers: headers})
      .subscribe((res: any) => {
        const messageData = {
            text: successMessage,
            type: 'info',
            icon: 'alert',
            sticky: false
          };
          this._errorService.handleCustomInfo(messageData);
          this.cardRemovedSubject$.next(true);
          this.cardRemovedRequestSent$.next(false);
      },
      err => {
        this._errorService.handleError(err);
        this.cardRemovedSubject$.next(false);
        this.cardRemovedRequestSent$.next(false);
      });

  }

}
